import styled from 'styled-components';

export const LiveCasinoNavbarOverflowDefaultBox = styled.div`
    display: flex;
    width: 100%;
    overflow-y: hidden;
    overflow-x: scroll;

    // Hides the scrollbar
    scrollbar-width: none; //Firefox
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    } // Chrome & Safari
`;